import { SimpleIconProps } from '../types';

export const IconComment = (props: SimpleIconProps) => {
  return (
    <svg fill="none" height="16" role="img" viewBox="0 0 16 16" width="16" {...props}>
      <path d="M5.33594 6.00008H4.0026V7.33341H5.33594V6.00008Z" fill="#2774AE" />
      <path d="M7.33594 6.00008H8.66927V7.33341H7.33594V6.00008Z" fill="#2774AE" />
      <path d="M12.0026 6.00008H10.6693V7.33341H12.0026V6.00008Z" fill="#2774AE" />
      <path
        clipRule="evenodd"
        d="M1.33594 13.3334L4.66927 10.6667H14.6693V2.66675H1.33594V13.3334ZM4.20158 9.33341L2.66927 10.5592V4.00008H13.3359V9.33341H4.20158Z"
        fill="#2774AE"
        fillRule="evenodd"
      />
    </svg>
  );
};
